module.exports = __webpack_public_path__ + "icon-star-off.svg?60132a436c241471fe8eab5b09ddf93b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-star-off.svg
// module id = 36
// module chunks = 0